export class Link {
    name: string;
    uri: string;
    description: string;
}
